import { render } from "./LevelOne.vue?vue&type=template&id=35c02eb0"
import script from "./LevelOne.vue?vue&type=script&lang=js"
export * from "./LevelOne.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__